// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__Zk7qQ","tab":"ProcedureTabs_tab__xzyrl"};